import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';



export const BuildModeApi = createApi({
    reducerPath: "build-mode",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["BuildMode"],
    endpoints: (builder) => ({
        getBuildMode: builder.query({
            query: ({ pageno, search, status, time, shopAdmin, buildStage, limit }) => {
                let url = `admin/builds?pageno=${pageno + 1}`;

                if (limit) {
                    url += `&limit=${limit}`
                }
                if (search) {
                    url += `&search=${search}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }
                if (time) {
                    url += `&time=${time}`;
                }
                if (shopAdmin) {
                    url += `&shopAdmin=${shopAdmin}`;
                }
                if (buildStage) {
                    url += `&buildStage=${buildStage}`;
                }
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ["BuildMode"],
        }),
        getSalesLead: builder.query({
            query: ({ pageno = 1, search, limit } = {}) => {
                let url = `admin/sales-lead?pageno=${pageno}`;

                if (limit) {
                    url += `&limit=${limit}`
                }
                if (search) {
                    url += `&search=${search}`;
                }
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ["BuildMode"],
        }),
        getBuildById: builder.query({
            query: ({ id ,url}) => ({
                url: `${url}/${id}`,
                method: "GET"
            }),
            transformResponse: (res) => res.body,
            providesTags: ["BuildMode"],
        },
        ),
        buildStatusToggle: builder.mutation({
            query: ({ id }) => ({
                url: `admin/build-status/${id}`,
                method: "PUT",
            }),
            invalidatesTags: ["BuildMode"],
        }),
        createBuild: builder.mutation({
            query: (data) => ({
                url: `admin/build`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["BuildMode"],
        }),
        updateBuild: builder.mutation({
            query: ({url, id, data }) => ({
                url: `${url}/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["BuildMode"],
        }),
        removeBuildContractor: builder.mutation({
            query: ({ id ,data}) => ({
                url: `/admin/build/contractor/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["BuildMode"],
        }),
        getBuildByContractor: builder.query({
            query: () => ({
                url: `/contractor/build`,
                method: "GET"
            })
        }),
        getBuildContractorBy: builder.query({
            query: ({ id }) => ({
                url: `/contractor/build/${id}`,
                method: "GET"
            })
        }),
        getBuildListByContractor: builder.query({
            query: ({ url:roleBaseUrl,pageno, search, status, time, shopAdmin, buildStage, limit }) => {
                let url = `${roleBaseUrl}?pageno=${pageno + 1}`;

                if (limit) {
                    url += `&limit=${limit}`
                }
                if (search) {
                    url += `&search=${search}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }
                if (time) {
                    url += `&time=${time}`;
                }
                if (shopAdmin) {
                    url += `&shopAdmin=${shopAdmin}`;
                }
                if (buildStage) {
                    url += `&buildStage=${buildStage}`;
                }
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ["BuildMode"],
        }),
        getBuildNotifications: builder.query({
            query: ({ id, build_type, pageno,limit }) => {
                let url = `notifications?pageno=${pageno}`
                if(id){
                    url += `&id=${id}`
                }
                if(build_type){
                    url += `&build_type=${build_type}`
                }
                if(limit){
                    url += `&limit=${limit}`
                }

                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ["BuildMode"],
        }),
        downloadAllPhotos: builder.query({
            query: ({id}) => ({
                url: `/admin/build/download-photos/${id}`,
                method: "GET",
                responseHandler: (response) => response.blob()
            })
        }),
        createBuildStage: builder.mutation({
            query: ({data,id}) => ({
                url: `admin/build/stage/${id}`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["BuildMode"],
        }),
        updateBuildStage: builder.mutation({
            query: ({ id, data }) => ({
                url: `admin/build/stage/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["BuildMode"],
        }),
        deleteBuildStage: builder.mutation({
            query: (id) => ({
                url: `admin/build/stage/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["BuildMode"],
        }),
        assignBuildStage: builder.mutation({
            query: ({id, data}) => ({
                url: `admin/build/stage/assign/${id}`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["BuildMode"],
        }),
        buildStageReorder: builder.mutation({
            query: (data) => ({
                url: `admin/build/stage/reorder`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["BuildMode"],
        }),
        hideBuildNotification: builder.mutation({
            query: (id) => ({
                url: `notifications/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["BuildMode"],
        }),
    }),
})

export const { useGetBuildModeQuery, useGetSalesLeadQuery, useBuildStatusToggleMutation, useCreateBuildMutation, useUpdateBuildMutation, useGetBuildByIdQuery, useRemoveBuildContractorMutation, useGetBuildByContractorQuery, useGetBuildContractorByQuery, useGetBuildListByContractorQuery, useGetBuildNotificationsQuery, useLazyDownloadAllPhotosQuery, useCreateBuildStageMutation, useUpdateBuildStageMutation, useDeleteBuildStageMutation, useAssignBuildStageMutation ,useBuildStageReorderMutation, useHideBuildNotificationMutation} = BuildModeApi